'use client';

export { default } from '@/shared/components/GlobalErrorBoundary.client';
